import {watch} from 'vue';
import {useSearchRouteDefinitions} from '@navbar/features/search';
import {SearchDisplayMode} from '@navbar/features/search/search.types';
import {useSearchDisplayMode} from '@navbar-logged/features/search';
import {defineStore} from 'pinia';
import {setCssVariable, useDisplayMobile} from '@malt/utils';
import {useHeaderNavigationTabs} from './composables';
import {useUserStore} from '../user';

export const useHeaderMenuStore = defineStore('navbar-header-menu', () => {
    const {isDisplayMobile} = useDisplayMobile();
    const userStore = useUserStore();
    const {searchDisplayMode, searchPreviewTarget, setSearchDisplayModeToForm} = useSearchDisplayMode();

    const {currentPage} = useSearchRouteDefinitions();

    const {headerNavigationTabs, onClientOnboardingIsPresent} = useHeaderNavigationTabs();

    function setTopNavPreviewDesktop() {
        setCssVariable('--header-menu-height', '70px');
        setCssVariable('--header-height', '70px');
        setCssVariable('--header-menu-item-margin-top', '0');
        setCssVariable('--layout-padding-top', '70px');
    }

    function setTopNavPreviewMobile() {
        setCssVariable('--header-menu-height', '145px');
        setCssVariable('--header-height', '145px');
        setCssVariable('--header-menu-item-margin-top', '0');
        setCssVariable('--layout-padding-top', '145px');
    }

    function setTopNavFormDesktop() {
        setCssVariable('--header-menu-height', '100px');
        setCssVariable('--header-height', '100px');
        setCssVariable('--header-menu-item-margin-top', '-30px');
        if (currentPage.value?.pushContent) {
            setCssVariable('--layout-padding-top', '100px');
        } else {
            setCssVariable('--layout-padding-top', '70px');
        }
    }

    function onDisplayModeChange() {
        if (import.meta.client && userStore.hasSelectedClientIdentity) {
            if (searchDisplayMode.value === SearchDisplayMode.PREVIEW) {
                if (isDisplayMobile.value) {
                    setTopNavPreviewMobile();
                } else {
                    setTopNavPreviewDesktop();
                }
            } else if (searchDisplayMode.value === SearchDisplayMode.FORM) {
                if (isDisplayMobile.value) {
                    setTopNavPreviewMobile();
                } else {
                    setTopNavPreviewDesktop();
                }
            } else {
                setTopNavPreviewDesktop();
            }
        }
    }

    function onDisplayMobileChange() {
        onDisplayModeChange();
    }

    watch(searchDisplayMode, onDisplayModeChange, {immediate: true});
    watch(isDisplayMobile, onDisplayMobileChange, {immediate: true});

    return {
        searchDisplayMode,
        searchPreviewTarget,
        setSearchDisplayModeToForm,
        headerNavigationTabs,
        onClientOnboardingIsPresent,
    };
});
